<script type="text/javascript">
export default {
  props: {
    transaction: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      loading: false,
      items: {},
      filters: {
        q: null,
      }
    }
  },
  mounted() {
    this.getItem()
  },
  methods: {
    getItem() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.transaction.iso_outbound', {
        transaction_uuid: this.transaction
      })+ '?q=')
        .then((response) => {
          if (response.data.data.length > 0) {
            this.items = response.data
          }
        })
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>

<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="loading" active>
      <a-tabs defaultActiveKey="outbound-0" tabPosition="left">
        <a-tab-pane :tab="moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')" v-for="(item,index) in items.data"
                  :key="`outbound-${index}`">
          <json-source :source="item"/>
        </a-tab-pane>
      </a-tabs>
    </a-skeleton>
  </a-card>
</template>
